import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// HOC to provide router props to class components in React Router v6
export function withRouter<P extends object>(
  Component: React.ComponentType<P>
) {
  function ComponentWithRouterProp(props: P) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
        match={{ params }}
        history={{ push: navigate }}
        location={location}
      />
    );
  }

  return ComponentWithRouterProp;
}
